// SUMMON Angular Modules and Application Initialization

const importAll: Function = (ctx: __WebpackModuleApi.RequireContext) => {
   ctx.keys().forEach(ctx)
}

if (module.hot) {

   module.hot.accept()
}
import('jquery')
import('angular')
require("./moduleDeclarations")
require('./urlRewriter')
require("./filters")
require("./values")
importAll(require.context("./constants/", true, /\.ts$/))
importAll(require.context("./controllers/", true, /\.ts$/))
importAll(require.context("./directives/", true, /\.ts$/))
importAll(require.context("./services/", true, /\.ts$/))
importAll(require.context("./factories/", true, /\.ts$/))
require("./initialize")
